// export const STRIPE_PUBLIC_KEY = "pk_test_51HfXCrIRAT2nHCkVKY8eqsCyDtbqksAUpSb8UGtK3uycbxyhgauOiySDlu1LyXP2pOj0pjXxkj2TQa7TXtdwth7c00Yk3yq34d";
export const STRIPE_PUBLIC_KEY =
  "pk_live_51HfXCrIRAT2nHCkVPruv3S40ncHgJ2WtSwbGfPrjy9GP1bKD8FUAtgYZjkLdsfVZJCjFymmWdp4fSiePmW8EB6Ep007LoAXUUk";
export const PRICE = 2999;
